import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { productCategoryInitialState } from "../initial-states/product-category.initial-state";
import { serviceCategoryInitialState } from "../initial-states/service-category.initial-state";

export interface IProductSubCategory {
  name: string;
  description: string;
  imgSrc?: string;
}

export interface IProductCategory {
  name: string;
  description: string;
  imgSrc: string;
  subCategories: IProductSubCategory[];
}

export interface IProductCategoryState {
  categories: IProductCategory[];
  mainCategory: IProductCategory;
  serviceCategories: IProductCategory[];
  mainSubCategoryIndex: number;
}

const initialState: IProductCategoryState = {
  categories: productCategoryInitialState,
  serviceCategories: serviceCategoryInitialState,
  mainCategory: productCategoryInitialState[0],
  mainSubCategoryIndex: 0,
};

const productCategorySlice = createSlice({
  name: "productCategory",
  initialState,
  reducers: {
    setMainProductCategory: (
      state: IProductCategoryState,
      action: PayloadAction<{
        category: IProductCategory;
        subCategoryIndex?: number;
      }>,
    ) => {
      if (action.payload.subCategoryIndex !== undefined) {
        state.mainSubCategoryIndex = action.payload.subCategoryIndex;
      }
      state.mainCategory = action.payload.category;
    },
  },
});

export const { setMainProductCategory } = productCategorySlice.actions;

export default productCategorySlice.reducer;
